import React, { useEffect, useLayoutEffect } from "react";
import PullToRefresh from "react-simple-pull-to-refresh";

import { useParams, useNavigationType } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDetailPageScroll,
  fetchDetailSummaryInfo,
  updateOrderPaymentList,
} from "redux/slices/sales/salesSlice";

import { getDetailTitle } from "utils/define";
import { useManagerPaymentQuery } from "queries/Sales/useManagerPaymentQuery";
import { toReferenceDate, PERIOD_COUNT } from "pages/Sales/_lib/toReferenceDate";

import MainLayout from "layouts/MainLayout";
import SummaryInfo from "./SummaryInfo";
import DetailList from "./DetailList";
import BottomBranch from "components/ui/popup/BottomBranch";
import PullToRefreshing from "components/common/PullToRefreshing";

/**
 * [기간별 매출]
 */

export const Detail = ({ mode }) => {
  const dispatch = useDispatch();
  const navigationType = useNavigationType();
  const { seqPartnerBranch } = useParams();

  let { searchPartner, searchBranch, searchDate, searchPeriodType } =
    useSelector((state) => state.sales.detailSummaryInfo);
  const partnerInfo = useSelector((state) => state.partner);
  const salesInfo = useSelector((state) => state.sales);

  useEffect(() => {
    if (
      !searchPartner ||
      (navigationType != "POP" &&
        (searchPartner != partnerInfo.seqPartner ||
          searchBranch != partnerInfo.seqPartnerBranch ||
          searchPeriodType != salesInfo.searchPeriodType))
    ) {
      dispatch(
        fetchDetailSummaryInfo({
          searchPartner: partnerInfo.seqPartner,
          searchBranch: Number(seqPartnerBranch) || partnerInfo.seqPartnerBranch,
          searchDate: salesInfo.searchDate,
          searchPeriodType: salesInfo.searchPeriodType,
        })
      );
    }
  }, []);

  useLayoutEffect(() => {
    return () => {
      dispatch(fetchDetailPageScroll("store"));
    };
  }, []);

  const query = useManagerPaymentQuery({
    seqPartner: searchPartner || partnerInfo.seqPartner,
    periodType: mode,
    referenceDate: searchDate ? toReferenceDate(mode, searchDate) : "",
    periodCount: PERIOD_COUNT[mode],
    seqPartnerBranches: searchBranch ? [searchBranch] : undefined,
  });

  const data = query.data
    ? {
        totalAmount: query.data.totalAmount,
        paymentMethods: query.data.paymentMethods,
        refund: query.data.refund,
        series: query.data.series,
      }
    : undefined;

  const eventHandler = {
    changeDate: (date) => {
      dispatch(fetchDetailSummaryInfo({ searchDate: date }));
    },
    changeBranch: (branch) => {
      dispatch(fetchDetailSummaryInfo({ searchBranch: branch }));
    },
    pullToRefresh: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          query.refetch();
          dispatch(updateOrderPaymentList(false));
          resolve();
        }, 700);
      });
    },
  };

  const render = () => {
    const getTitle = () => {
      const suffix =
        (mode == "daily"
          ? "일간"
          : mode == "weekly"
            ? "주간"
            : mode == "monthly"
              ? "월간"
              : "") + " 매출";
      return getDetailTitle(partnerInfo, searchPartner, searchBranch, suffix);
    };
    const isChart = mode != "daily";
    return (
      <PullToRefresh
        onRefresh={eventHandler.pullToRefresh}
        resistance={2}
        pullingContent={<></>}
        refreshingContent={<PullToRefreshing />}
      >
        <MainLayout
          withHeader={true}
          headerProps={{
            withBackButton: true,
            centerTitle: getTitle(),
          }}
          backgroundColor="white"
          withBottomTab={false}
        >
          <SummaryInfo
            mode={mode}
            date={searchDate}
            data={data}
            isChart={isChart}
            isLoading={query.isLoading}
            isError={query.isError}
            onChange={eventHandler.changeDate}
            onRefresh={() => query.refetch()}
          />
          <DetailList />
          <BottomBranch
            searchBranch={searchBranch}
            onChange={eventHandler.changeBranch}
          />
        </MainLayout>
      </PullToRefresh>
    );
  };
  return render();
};

export default Detail;
